// Labels for escalation trigger_reason codes on the teacher dashboard (and so in its class CSV).
//
// Only codes from a fixed vocabulary get their own label. Anything else — free text in escalation
// rows from before the server allowlist — is shown and exported as the "other" label, never as the
// raw text (supervisory Codex review A+D, P2). The server folds such values into "other" too
// (routers/analytics.py _normalize_trigger_reason_for_summary); this is the second layer.

// Cognitive axes — order preserved for the cognitive-difficulty panel.
export const COGNITIVE_KEYS = [
  'working_memory', 'visuospatial', 'crossmodal', 'load_vulnerability',
  'executive_inhibition', 'language_semantic', 'math_anxiety', 'graph_literacy',
];

// Older event codes that resolve via dashboard.trigger.* (mirrored in the server's
// _LEGACY_TRIGGER_EVENT_CODES).
export const TRIGGER_REASON_KEYS = [
  'long_silence', 'explicit_request', 'low_confidence', 'repeated_question',
  're_question', 're_click', 'idle', 'wrong_answer', 'label_question',
];

export function triggerReasonLabel(code, t) {
  if (TRIGGER_REASON_KEYS.includes(code)) return t(`dashboard.trigger.${code}`);
  if (COGNITIVE_KEYS.includes(code)) return t(`dashboard.cog.${code}`);
  if (code === null || code === undefined || code === '') return t('dashboard.teacher.uncategorized');
  return t('dashboard.teacher.dbrOtherLabel');
}
